/**
 * SRES · Unified report-generation success toast.
 * Feb 2026 · Navigation-simplification pass.
 *
 * The client mandate is that once ANY report is generated (CPR, Log
 * Book, GIS ZIP, technical export, custom report, etc.) the UI must
 * NOT show a scattered download button in the current module. Instead
 * we surface a single, unambiguous message:
 *
 *   "Report generated successfully. It is available in the Reports Panel."
 *
 * along with a one-click link to open the Reports Panel where the
 * user finds every artefact for the current project.
 */
import { toast } from "sonner";

export function toastReportReady({ projectId, navigate, kind = "Report" } = {}) {
  toast.success(
    `${kind} generated successfully. It is available in the Reports Panel.`,
    {
      duration: 6000,
      description: "All reports · maps · logs · exports live in one place.",
      action: (projectId && navigate) ? {
        label: "Open Reports Panel",
        onClick: () => navigate(`/app/projects/${projectId}/reports`),
      } : undefined,
      id: `report-ready-${projectId || "generic"}`,
    },
  );
}

/**
 * Convenience helper for callers that already have a specific report ID
 * — includes the ID in the toast description so users know which one.
 */
export function toastSpecificReportReady({ projectId, navigate, kind = "Report", reportId, filename } = {}) {
  toast.success(
    `${kind} generated successfully. It is available in the Reports Panel.`,
    {
      duration: 8000,
      description: filename ? `File: ${filename}` : (reportId ? `Report ID: ${reportId}` : "Open the Reports Panel to preview or download."),
      action: (projectId && navigate) ? {
        label: "Open Reports Panel",
        onClick: () => navigate(`/app/projects/${projectId}/reports`),
      } : undefined,
      id: reportId ? `report-ready-${reportId}` : `report-ready-${projectId || "generic"}`,
    },
  );
}
